import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
// import { useQuery } from "react-query";
import {
  useNotify,
  SimpleForm,
  TextInput,
  // SelectInput,
  NumberInput,
  useResourceContext,
  required,
  number,
  maxLength,
  useRefresh,
  // useDataProvider,
  useUpdate,
  Edit,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import Transition from "../../transition/Transition";

// const validateCompany = [required()];
const validateCode = [required(), number()];
const validateName = [required(), maxLength(125)];

export default function SalesAreaEditDialog({ open, setOpen, recordId }) {
  const [update] = useUpdate();
  const notify = useNotify();
  const resource = useResourceContext(); // cuman nama resource
  const refresh = useRefresh();
  // const dataProvider = useDataProvider();

  // GET COMPANY LISTS
  // const {
  //   data: companies,
  //   isLoading: isLoadingCompanies,
  //   error: companyError,
  // } = useQuery(["companies/select", "getListNoParams"], () =>
  //   dataProvider.getListNoParams("companies/select")
  // );
  // GET COMPANY LISTS

  const save = useCallback(
    async (values) => {
      try {
        await update(
          resource,
          { id: values.id, data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.updated", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body.errors) {
          // The shape of the returned validation errors must match the shape of the form
          return error.body.errors;
        }
      }
    },
    [update]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted={false}
      TransitionComponent={Transition}
    >
      <Edit
        title={" "}
        id={recordId}
        actions={false}
        sx={{ "& .RaEdit-main": { mt: 0 } }}
      >
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>Edit Sales Area</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <TextInput disabled source="id" sx={{ display: "none" }} />

            {/* <SelectInput
              variant="outlined"
              source="company_id"
              isRequired
              choices={isLoadingCompanies ? [] : companies}
              fullWidth
              validate={validateCompany}
            /> */}

            <NumberInput
              variant="outlined"
              source="code"
              fullWidth
              isRequired
              // disabled
              validate={validateCode}
            />

            <TextInput
              variant="outlined"
              source="name"
              label="Area"
              fullWidth
              isRequired
              validate={validateName}
            />
          </DialogContent>
        </SimpleForm>
      </Edit>
    </Dialog>
  );
}
